import { graphql } from './client';

const MUTATION = `
    mutation RecordMfaEnrolment {
        recordMfaEnrolment {
            enabledAt
        }
    }
`;

/**
 * Records that this person has just registered a second factor for the first time
 * (PCG-303).
 *
 * **AN EVENT, NOT A STATE, and that is why this call is short.** Whether somebody carries
 * a factor now is read from the pool, by the back-office, on the screen that asks: it is
 * a live property that changes without us, so nothing here declares it. What this records
 * is the moment of compliance, which the pool cannot answer, `AdminGetUser` saying what is
 * registered and never since when.
 *
 * There is therefore **no method argument and no removal call**. An event does not
 * un-happen: somebody who later removes their factor did comply on that date, and the
 * pool will say they have none the next time anybody looks.
 *
 * **Attention, IT NEVER SURFACES ITS FAILURE, and that is deliberate.** The factor is
 * registered in the pool whatever this call does. Telling the person « impossible
 * d'enregistrer votre double authentification » right after Cognito accepted it would be
 * false, and would send them to retry something that succeeded. What it costs when it
 * fails is a back-office sheet showing the factors without the date of compliance, which
 * is a missing line rather than a wrong one.
 */
export const recordMfaEnrolment = (idToken: string): void => {
    void graphql(MUTATION, undefined, idToken).catch(() => {
        // Rien : voir ci-dessus.
    });
};
